module.exports = __webpack_public_path__ + "img/09.ce9a6744.jpg";